import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CreatePlayer } from './CreatePlayer'

const PlayerCreationPage = props => <CreatePlayer key={props.userDetails?.id || props.userDetails?._id} {...props} />

export default connect(({ session }) => ({ settings: session.settings, userDetails: session.userDetails }))(withRouter(PlayerCreationPage))
